<template>
  <div class="PhotoGallery">
    <div class="grid">
      <div v-for="index in imageSlots.length" :key="index" class="grid-item" :class="[`pic-${index}`]"
        @click="openModal(index - 1)">
        <slot :name="`grid-item-image-slot-${index}`"></slot>
      </div>
    </div>
    <div :id="'overlay-' + _uid" class="overlay" @click="closeModal()">
      <carousel class="photo-page-carousel white-pagination" v-if="activeModal" :options="{
        slidesPerView: 1,
        loop: true,
        observer: true,
        observeParents: true,
        parallax: true,
        centeredSlides: true,
        initialSlide: activePhoto,
        pagination: {
          dynamicBullets: true,
        },
        autoHeight: true,
        navigation: {
          nextEl: '.inner-swiper-button-next',
          prevEl: '.inner-swiper-button-prev',
        }
      }">
        <carousel-item v-for="index in imageSlots.length" :key="'subitem-fullscreen-' + index">
          <div class="slide-container">
            <div class="image-container">
              <slot :name="`grid-item-image-slot-${index}`"></slot>
            </div>
            <div class="text-container">
              <div class="content">
                <h3 class="tag">
                  <slot :name="`grid-item-tag-slot-${index}`"></slot>
                </h3>
                <div>
                  <slot :name="`grid-item-description-slot-${index}`"></slot>
                </div>
              </div>
            </div>
          </div>
        </carousel-item>
      </carousel>
      <div class="close-modal-social-icon">
        <img :id="'overlay-' + _uid + '-close'" class="close-modal" src='@images/close-modal-icon.png' alt="close"
          @click="closeModal()">
      </div>

    </div>
  </div>
</template>
<script>
import Icon from '@components/atoms/icon'
import Carousel from '@components/carousel/carousel'
import CarouselItem from '@components/carousel/carousel-item'

export default {
  name: 'PhotoGallery',
  components: {
    Icon, Carousel, CarouselItem
  },
  data() {
    return {
      activeModal: false,
      activePhoto: 0,
    };
  },
  methods: {
    openModal(activePhoto) {
      if (this.$parent.$el) {
        this.$parent.$el.style.zIndex = "99999"
      }
      const modal = document.getElementById('overlay-' + this._uid);
      const modalCloseButton = document.getElementById('overlay-' + this._uid + '-close');
      const header = document.querySelector('.BaseHeader');

      modal.style.display = 'block';
      modalCloseButton.style.display = 'block';
      document.body.style.overflow = 'hidden'
      header.style.display = 'none';
      this.activeModal = true;
      this.activePhoto = activePhoto;
      modal.addEventListener('click', () => {
        document.body.style.overflow = 'visible'
        modal.style.display = 'none';
        header.style.display = 'block';
        modal.removeEventListener('click', null);
        modalCloseButton.style.display = 'none';
        modalCloseButton.removeEventListener('click', null);
        if (this.$parent.$el) {
          this.$parent.$el.style.zIndex = "0"
        }
      })
      modalCloseButton.addEventListener('click', () => {
        document.body.style.overflow = 'visible'
        modal.style.display = 'none';
        header.style.display = 'block';
        modal.removeEventListener('click', null);
        modalCloseButton.style.display = 'none';
        modalCloseButton.removeEventListener('click', null);
        if (this.$parent.$el) {
          this.$parent.$el.style.zIndex = "0"
        }
      })

    },
    closeModal() {
      this.activeModal = false;
    },
  },
  computed: {
    imageSlots: function () {
      return Object.keys(this.$slots).filter((key) => key.includes('grid-item-image-slot'))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~$scss/_variables";

.PhotoGallery {
  .grid {
    display: grid;
    gap: 8px;
    grid-auto-rows: 163px;
    grid-template-columns: repeat(2, 163px);

    @media screen and (min-width: $bootstrap-md) {
      column-gap: 24px;
      row-gap: 20px;
      grid-auto-rows: 223px;
      grid-template-columns: repeat(3, 223px);
    }

    @media screen and (min-width: $max-viewport-width) {
      column-gap: 24px;
      row-gap: 24px;
      grid-auto-rows: 408px;
      grid-template-columns: repeat(3, 408px);
    }


    .grid-item {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        overflow: hidden;
      }
    }

    .pic-1,
    .pic-8 {
      grid-row: span 2;
    }

    .pic-13 {
      grid-column: span 2;
    }

    .pic-7 {
      @media screen and (min-width: $bootstrap-md) {
        grid-column: span 2;
      }
    }
  }

  .overlay {
    background-color: #00142FBF;
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: hidden !important;
    top: 0px;
    left: 0px;
    z-index: 9999;
    display: none;
    align-content: center;
  }

  .close-modal {
    width: 100%
  }

  .Carousel{
    padding: 70px 0 40px;

    @media screen and (min-width: $bootstrap-md) {
      padding: 40px 0 40px;
    }
  }

  ::v-deep .swiper-pagination{
    @media(min-width:$bootstrap-md){
      display: block !important;
    }
    @media(min-width:$bootstrap-lg){
      display: none !important;
    }
  }

  ::v-deep .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    

    .slide-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
      width: 95%;
      @media screen and (min-width: $bootstrap-lg) {
        max-height: 75vh;
      }


      @media screen and (min-width: $bootstrap-lg) {
        flex-direction: row;
        align-items: center;
        width: 80%;
      }

      .image-container {
        max-height: 75vh;
        // @media screen and (min-width: $bootstrap-lg) {
        //   flex: 1 1 min-content;
        // }

        img {
          width: 100%;
          max-height: 75vh;
          object-fit: contain;
          object-position: center !important;
        }
      }

      .text-container {
        
        max-height: calc(32vh - 74px);
        align-self: stretch;
        background-color: white;
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
        
        padding-bottom: 35px;
      
        @media screen and (min-width: $bootstrap-lg) {
          max-height: none;
          flex: 0 0 30%;
          min-width: 250px;
        }


        .content{
        @media screen and (min-width: $bootstrap-lg) {
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          height: min-content;
          width: 100%;
        }
          padding: 35px 24px 0px;
        }

        .tag {
          color: $color-blue;
          font-size: 18px;
        }
      }
    }
  }



}
</style>